module.exports = __webpack_public_path__ + "static/media/SmartShop_7-1080w.b3b25333.webp";